export enum EvaluationStatus {
    "Pending" = "pending",
    "Rejected" = "rejected",
    "Approved" = "approved",
}
